










































































































































import { rules } from './../../rules';
import { cashbackRules } from '@/components/Cashback/rules';
import {
  currencyKeyboardEventValidation,
  currencyEvent
} from '@/util/CurrencyValidation';
import copyObj from '@/util/copyObj';
import { ValidationProvider } from 'vee-validate';
import { tRule } from '../../types/rules';
import { allowAny, tTeipSelectServerRef } from 'teip-components';
import { http } from '@/util/HTTP';
import {
  rulesDiscountAndCasbacks,
  tRuleDataKey,
  tRulesDiscountAndCashbacks
} from '@/store/interfaces/discountAndCashbackRules';
import rulesDiscountAndCashbacks from '@/store/types/rulesDiscountAndCashbacks';
import BinsNumber from '@/components/Cashback/binsNumber.vue';
import { isCashbackRoute } from '@/components/Cashback/routeValidation';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Segmentation',
  components: { BinsNumber, },
  props: {
    isModalActive: {
      type: Boolean,
      required: true,
    },
    updateRule: {
      type: Object as PropType<rulesDiscountAndCasbacks>,
      required: true,
    },
  },
  data: () => ({
    ids: {
      commerce_ids: [],
      branch_ids: [],
      commerce_kind_ids: [],
      user_ids: [],
    },
    defaultOptions: {
      commerce_ids: [],
      branch_ids: [],
      commerce_kind_ids: [],
      user_ids: [],
      numbers: [],
    },
    integerValue: 0,
    transaction_amount_cents: '',
    average_amount_cents: '',
    segmentation: '',
    segmentations: [] as tRule[],
    isAverageMount: false,
    isBinNumber: false,
    byUser: false,
    byCommerce: false,
    byBranches: false,
    isTransactionCount: false,
    byCommerceKind: false,
    isTransactionAmount: false,
    isUpdate: false,
    http: http,
    currencyKeyboardEventValidation: currencyKeyboardEventValidation,
    currencyEvent: currencyEvent,
  }),
  computed: {
    ...mapGetters({
      rulesValidated: `discountAndCashbackRules/${rulesDiscountAndCashbacks.getters.GET_RULES_VALIDATED}`,
    }),
    isActiveModal: {
      get(): boolean {
        return this.isModalActive;
      },
      set(value: boolean): void {
        this.$emit('update:isModalActive', value);
      },
    },
    segmentationsValidates(): tRule[] {
      const segmentations = copyObj(this.segmentations);
      return segmentations.filter((segmentation) => {
        return !this.rulesValidated.includes(
          segmentation.id as tRulesDiscountAndCashbacks
        );
      });
    },
  },
  created(): void {
    this.filledSegmentations();
  },
  methods: {
    filledSegmentations(): void {
      if (isCashbackRoute(this.$route)) {
        this.segmentations = copyObj<tRule[]>(cashbackRules);
      } else {
        this.segmentations = copyObj<tRule[]>(rules);
      }
      this.segmentations.splice(0, 1);
    },
    resetSegmentation(): void {
      this.integerValue = 0;
      this.transaction_amount_cents = '';
      this.average_amount_cents = '';
      this.segmentation = '';
      this.isUpdate = false;
      this.isAverageMount = false;
      this.byUser = false;
      this.byCommerce = false;
      this.byBranches = false;
      this.byCommerceKind = false;
      this.isTransactionCount = false;
      this.isTransactionAmount = false;
      (
        this.$refs.formTargetValidation as InstanceType<
          typeof ValidationProvider
        >
      ).reset();
      this.$emit('reset', true);
    },
    save(): void {
      if (this.isBinNumber) {
        if (this.defaultOptions.numbers.length === 0) {
          (
            this.$refs.formTargetValidation as InstanceType<
              typeof ValidationProvider
            >
          ).setErrors({
            bins: ['Debes agregar al menos un bin'],
          } as allowAny);
          return;
        }
      }

      const rule = this.segmentations.filter(
        (segmentation) => segmentation.id === this.segmentation
      )[0];

      const ruleToAdd: rulesDiscountAndCasbacks = {
        data: {},
        meta: [],
        rule: 'all',
      };

      switch (rule.ref) {
      case 'user_ids':
        // eslint-disable-next-line no-case-declarations
        const usersIds: rulesDiscountAndCasbacks = this.filledRule(
          rule.ref,
          rule.id,
          this.ids.user_ids,
          (this.$refs.findByUser as tTeipSelectServerRef).data,
          'handle'
        );
        ruleToAdd.data = usersIds.data;
        ruleToAdd.meta = usersIds.meta;
        break;

      case 'transaction_amount_cents':
        ruleToAdd.data = {
          transaction_amount_cents:
              Number(this.transaction_amount_cents) * 100,
        };
        break;
      case 'commerce_ids':
        // eslint-disable-next-line no-case-declarations
        const commerceFilled: rulesDiscountAndCasbacks = this.filledRule(
          rule.ref,
          rule.id,
          this.ids.commerce_ids,
          (this.$refs.findByCommerce as tTeipSelectServerRef).data,
          'name'
        );
        ruleToAdd.data = commerceFilled.data;
        ruleToAdd.meta = commerceFilled.meta;
        break;
      case 'branch_ids':
        // eslint-disable-next-line no-case-declarations
        const branchsFilled: rulesDiscountAndCasbacks = this.filledRule(
          rule.ref,
          rule.id,
          this.ids.branch_ids,
          (this.$refs.findByBranch as tTeipSelectServerRef).data,
          'name'
        );
        ruleToAdd.data = branchsFilled.data;
        ruleToAdd.meta = branchsFilled.meta;
        break;
      case 'commerce_kind_ids':
        // eslint-disable-next-line no-case-declarations
        const commerceKidsFilled: rulesDiscountAndCasbacks = this.filledRule(
          rule.ref,
          rule.id,
          this.ids.commerce_kind_ids,
          (this.$refs.findByCommerceKind as tTeipSelectServerRef).data,
          'name'
        );
        ruleToAdd.data = commerceKidsFilled.data;
        ruleToAdd.meta = commerceKidsFilled.meta;

        break;
      case 'transactions_count':
        ruleToAdd.data = {
          transactions_count: this.integerValue,
        };
        break;
      case 'average_amount_cents':
        ruleToAdd.data = {
          average_amount_cents: Number(this.average_amount_cents) * 100,
        };
        break;
      case 'bin_numbers':
        ruleToAdd.data = {
          numbers: this.defaultOptions.numbers,
        };
        break;
      }

      ruleToAdd.rule = rule.id;

      this.$emit('rule', ruleToAdd);
      this.resetSegmentation();
    },

    cancel(): void {
      this.resetSegmentation();
    },

    filledRule(
      ruleKey: tRuleDataKey,
      rule: tRulesDiscountAndCashbacks,
      ids: string[] | string,
      data: Array<allowAny> | Record<string, string>,
      keyOfName: string
    ): rulesDiscountAndCasbacks {
      return {
        rule,
        data: { [ruleKey]: typeof ids === 'string' ? [ids] : ids, },
        meta: Array.isArray(data)
          ? data
            .filter((d) => ids.includes(d.id))
            .map((d) => ({ name: d[keyOfName], id: d.id, }))
          : [{ name: data[keyOfName], id: data.id, }],
      };
    },
  },
  watch: {
    updateRule(rule: rulesDiscountAndCasbacks): void {
      let segmentation = this.segmentations.find((r) => r.id === rule.rule);

      if (isCashbackRoute(this.$route)) {
        segmentation = cashbackRules.find((r) => r.id === rule.rule);
      }

      if (segmentation) {
        this.segmentation = segmentation.id;
        const key = Object.keys(rule.data)[0];

        if (key && typeof rule.data[key] === 'object') {
          (this.defaultOptions as Record<string, string[]>)[key] = rule.data[
            key
          ] as string[];
        } else {
          this.defaultOptions = {
            commerce_ids: [],
            branch_ids: [],
            commerce_kind_ids: [],
            user_ids: [],
            numbers: [],
          };
        }

        this.integerValue =
          typeof rule.data[segmentation.ref] === 'number'
            ? (rule.data[segmentation.ref] as number)
            : 0;

        if (segmentation.ref === 'transaction_amount_cents') {
          this.transaction_amount_cents = String(
            Number(rule.data[segmentation.ref]) / 100
          );
        }

        if (segmentation.ref === 'average_amount_cents') {
          this.average_amount_cents = String(
            Number(rule.data[segmentation.ref]) / 100
          );
        }

        this.isUpdate = true;
      }
    },
    segmentation(seg: string): void {
      this.isBinNumber = seg.includes('bin_numbers');
      this.isAverageMount = seg.includes('average_amount');
      this.byUser = seg.includes('users');
      this.byCommerce = seg.includes('commerces');
      this.byBranches = seg.includes('branches');
      this.byCommerceKind = seg.includes('commerce_kinds');
      this.isTransactionCount = seg.includes('transactions_count');
      this.isTransactionAmount = seg.includes('transactions_amount');
    },
  },
});
